import { z } from "zod";

/**
 * Tool extract keys — stored in AgentExternalTool.extractKeys Json field.
 * Controls which keys from the API response are included in the agent's context.
 * `true` = include key, `false` = exclude key.
 * Mirrors `agentExternalToolSchema.extractKeys` in
 * shared/domain/tools/external-tool-config.ts.
 */
export const ToolExtractKeysSchema = z.record(z.string(), z.boolean()).nullable();

export type ToolExtractKeys = z.infer<typeof ToolExtractKeysSchema>;
